import React, { useRef, useEffect } from 'react';
const HTMLEmail = (props) => {
    const frame = useRef(null);
    const setContentHeight = (doc) => {
        var _a;
        const height = (_a = doc === null || doc === void 0 ? void 0 : doc.body) === null || _a === void 0 ? void 0 : _a.scrollHeight;
        if (height && frame && frame.current) {
            frame.current.style.height = `${height}px`;
        }
    };
    const updateFrame = (props) => {
        if (frame && frame.current) {
            const contentWindow = frame.current.contentWindow;
            if (contentWindow) {
                const doc = contentWindow.document;
                doc.open();
                doc.write(`<div><style>body { overflow: hidden; } img { max-height: 200px}</style>${props ? props.html : ''}</div>`);
                doc.close();
                frame.current.style.height = '0';
                contentWindow.onload = () => {
                    setContentHeight(doc);
                };
            }
        }
    };
    useEffect(() => {
        updateFrame();
    }, []);
    useEffect(() => {
        updateFrame(props);
    }, [props.html]);
    return (React.createElement("iframe", { style: {
            width: '100%',
            border: 'none',
            height: 'auto',
        }, src: "about:blank", ref: frame, sandbox: "allow-same-origin allow-scripts", className: "ui-test-5c14306c" }));
};
export default HTMLEmail;
//# sourceMappingURL=HTMLEmail.js.map